import * as React from 'react'; 


export interface ImgNumDisplayProps{
    className?:string;
    currentImg: number;
    numOfImgs: number;
}


export const ImgNumDisplay: React.SFC<ImgNumDisplayProps> = (props)=>{

    let cls = props.className || "";
    
    return (
        <div className={"img-num-display " + cls}>
            <p className="current">{props.currentImg < 10 ? "0" + props.currentImg : props.currentImg}</p>
            <div className="slash"></div>
            <p className="max">{props.numOfImgs}</p>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/ui/ImgNumDisplay/ImgNumDisplay.tsx